module.exports = __webpack_public_path__ + "img/Party-text.9cb205c9.jpg";